import React from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment-timezone';

import AppContainer from './container';
import { unregister } from './registerServiceWorker';
import zhHansConfig from './components/common/momentLocale/zhHans';

moment.locale('zh-Hans', zhHansConfig);
moment.tz.add('Asia/Beijing|CST CDT|-80 -90|01010101010101010|-1c1I0 LX0 16p0 1jz0 1Myp0 Rb0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6');
moment.tz.add('Asia/Guangzhou|CST CDT|-80 -90|01010101010101010|-1c1I0 LX0 16p0 1jz0 1Myp0 Rb0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6');

ReactDOM.render(<AppContainer />, document.getElementById('content'));
unregister();



// WEBPACK FOOTER //
// ./src/index.js